import React from 'react';
import Icon from '../icons/Icon';
import { IconLibrary } from '../../../interfaces/icon/IconLibrary';

export interface IIconButton {
    ariaLabel: string;
    className?: string,
    onButtonClick?: () => void;
    isDisabled?: boolean;
    iconName: IconLibrary,
}

const IconButton = ({ ariaLabel, className, isDisabled = false, onButtonClick, iconName}: IIconButton) => {
    return (
        <button
            className={`icon-button ${className ?? ""}`}
            disabled={isDisabled}
            aria-label={ariaLabel}
            onClick={onButtonClick}
            type={'button'}
        >
            <Icon iconName={iconName} sizeInPx='12' color='var(--thriveCharcoal)'/>
        </button>
    );
};

export default IconButton